import {HTTP_METHODS} from '@/utils/constants/httpMethods'

export const PROMOTION_PRODUCT_SELECTION_CONFIG = {
  PRODUCT_DROPDOWN_LIST: (dropDownType = '') => ({
    endPoint: `dropdowns/${dropDownType}`,
    method: HTTP_METHODS.GET,
    baseUrlKey: 'inventoryApiUrl',
  }),
  GTIN_ALL: (queryParams = {}) => ({
    endPoint: `gtin?${new URLSearchParams(queryParams).toString()}`,
    method: HTTP_METHODS.GET,
    baseUrlKey: 'inventoryApiUrl',
  }),
  GTIN_DETAILS: (gtinId = '', queryParams = {}) => ({
    endPoint: `gtin/${gtinId}?${new URLSearchParams(queryParams).toString()}`,
    method: HTTP_METHODS.GET,
    baseUrlKey: 'inventoryApiUrl',
  }),
}
